import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const fetchHotlistsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.BENCHSALES_HOTLIST.GET_ALL,
    params: {
      ...params,
      coll: "Hotlist",
    },
  });
};

export const addHotlistApi = async (data) => {
  return await axiosRequest({
    method: "POST",
    url: ENDPOINTS.BENCHSALES_HOTLIST.ADD,
    data,
    params: {
      coll: "Hotlist",
    },
  });
};

export const updateHotlistApi = async ({ uiid, payload }) => {
  return await axiosRequest({
    method: "PATCH",
    url: ENDPOINTS.BENCHSALES_HOTLIST.UPDATE,
    data: { payload },
    params: {
      coll: "Hotlist",
      uiid,
    },
  });
};

export const deleteHotlistApi = async ({ uiid }) => {
  return await axiosRequest({
    method: "DELETE",
    url: ENDPOINTS.BENCHSALES_HOTLIST.DELETE,
    params: {
      coll: "Hotlist",
      uiid,
    },
  });
};

export const getAllUsersApi = async () => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.USER_REFS.BS_GET_USERREF,
    params: {
      pg: 1,
      lim: 1000, 
      ret: "uiid reportTo",
      fil: JSON.stringify({
         "role.type": { type: "IN", value: [1, 2, 3, 4] } 
      }),
    },
  });
};
